import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import AnchorNavStore from './store';
import cx from 'classnames';

const styles = require('./index.less');

/**
 * 页面滚动屏的锚点导航组件
 * @param {AnchorNavStore} store - 组件状态管理
 * @constructor
 */
const AnchorNav = ({ store, className }) => {
  store.use();

  const AnchorItem = ({ text, subTextImg, active, onClick }) => {
    return (
      <div className={cx(styles.anchorItem, active && styles.active)} onClick={onClick}>
        <div className={styles.anchorItemText}>{text}</div>
        <img alt="" className={styles.anchorItemSubText} src={subTextImg} />
      </div>
    );
  };

  return (
    <div className={cx(styles.root, className)}>
      {store.anchorList.map((item, index) => (
        <AnchorItem
          key={index}
          text={item.text}
          subTextImg={item.subTextImg}
          active={index === store.activeIndex}
          onClick={() => store.setActiveIndex(index)}
        />
      ))}
    </div>
  );
};

export default wrapStore(AnchorNav, AnchorNavStore);
